import ClassNames from "classnames";
import { FunctionComponent, ReactNode } from "react";
import styles from "../stylesheets/components/typography-content.module.css";

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

const TypographyContent: FunctionComponent<Props> = ({
  className,
  children,
  ...props
}) => {
  return (
    <div className={ClassNames(styles.TypographyContent, className)} {...props}>
      {children}
    </div>
  );
};

export default TypographyContent;
